import React from 'react';
import { call, fork, put, takeEvery } from 'redux-saga/effects';

import * as ga from '../../redux/actions/app';
import { push } from 'react-router-redux';
import {
  saveMatchingConfigToRedux,
  getMatchingConfigParametersDataSuccess,
  NS_SAVE_MATCHING_CONFIG_DATA,
  NS_GET_MATCHING_CONFIG_PARAMATERS_DATA,
  NS_GET_MATCHING_CONFIG_LIST,
  getNSMatchingConfigListDataSuccess,
  getNSMatchingConfigListDataFail,
  NS_POST_CREATE_MATCHING_CONFIG,
  postNSCreateMatchingConfigSuccess,
  postNSCreateMatchingConfigFail,
  NS_GET_MATCHING_CONFIG_BY_ID,
  getNSMatchingConfigByIdSuccess,
  getNSMatchingConfigByIdFail,
  NS_PUT_UPDATE_MATCHING_CONFIG,
  NS_GET_MATCHING_CONFIG,
  putNSUpdateMatchingConfigSuccess,
  putNSUpdateMatchingConfigFail,
  NS_GET_MATCHING_CONFIG_RISK_INDICATOR_LIST,
  getNSMatchingConfigRiskIndicatorListSuccess,
  getNSMatchingConfigRiskIndicatorListFail,
  NS_GET_MATCHING_CONFIG_RISK_INDICATORS_DATA,
  getNSMatchingConfigRiskIndicatorParametersSuccess,
  getNSMatchingConfigSuccess,
  getNSMatchingConfigFail
} from '../../redux/actions/ns/matchingConfig';

import {
  getNSMatchingConfigList,
  getMatchingConfigParameters,
  getMatchingConfigRiskIndicatorsParameters,
  postNSCreateMatchingConfigAPI,
  getNSMatchingConfigByIdService,
  putNSUpdateMatchingConfigAPI,
  getNSMatchingConfigAPI,
  getMatchingConfigRiskIndicatorList
} from '../../services/ns/matchingConfig';
import { notification } from 'antd';
import { ROUTE_AMLS_SMART_SCREENING } from '../../pages/constants/globalConstants';

import { forEach } from '../../util/lodashlike';
export function* saveMatchingConfigToSagaStore(payload) {
  try {
    yield put(saveMatchingConfigToRedux(payload));
  } catch (err) {
    console.log('err :', err);
  }
}

export function* watchsaveMatchingConfigToStore() {
  yield takeEvery(NS_SAVE_MATCHING_CONFIG_DATA, function* ({ payload }) {
    yield fork(saveMatchingConfigToSagaStore, payload);
  });
}

function* getMatchingConfigParametersDataWorker(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(getMatchingConfigParameters, payload);
    let data = [];
    forEach(response.data, function (obj) {
      let p = [];
      forEach(obj?.parameterList, (parameter) => {
        let o = {
          ...parameter,
          recommendedScore:
            parameter.recommendedScore >= 1 ? 1 : parameter.recommendedScore
        };
        p.push(o);
      });

      data.push({
        ...obj,
        parameterList: p
      });
    });
    yield put(getMatchingConfigParametersDataSuccess(data));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: 'Error in tuning parameters api call' }));
  }
}

export function* watchGetMatchingConfigParametersData() {
  yield takeEvery(
    NS_GET_MATCHING_CONFIG_PARAMATERS_DATA,
    function* ({ payload }) {
      yield fork(getMatchingConfigParametersDataWorker, payload);
    }
  );
}
function* getMatchingConfigListDataWorker(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(getNSMatchingConfigList, payload);
    yield put(getNSMatchingConfigListDataSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(getNSMatchingConfigListDataFail({ error: '' }));
    yield put(ga.fetchFailed({ error: '' }));
  }
}

export function* watchGetMatchingConfigListData() {
  yield takeEvery(NS_GET_MATCHING_CONFIG_LIST, function* ({ payload }) {
    yield fork(getMatchingConfigListDataWorker, payload);
  });
}

function* postCreateMatchingConfigWorker(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(postNSCreateMatchingConfigAPI, payload);
    if (response?.status === 200 || response?.status === 201) {
      notification.open({
        message: (
          <p>
            <i style={{ color: '#2ecc71' }} className="fa fa-check"></i>
            &nbsp;&nbsp;Success
          </p>
        ),
        description: `${payload.name} is added successfully.`
      });
      yield put(postNSCreateMatchingConfigSuccess(response.data));
      yield put(ga.fetchSuccess());
      yield put(push(`${ROUTE_AMLS_SMART_SCREENING}/matchingConfig`));
    } else throw { errorMessage: response?.data?.msg };
  } catch (error) {
    yield put(postNSCreateMatchingConfigFail({ error: '' }));
    yield put(ga.fetchFailed({ error: '' }));
    notification.open({
      message: (
        <p>
          <i style={{ color: '#e74c3c' }} className="fa fa-close"></i>
          &nbsp;&nbsp;{' '}
          {error?.errorMessage ? error.errorMessage : 'Something went wrong !'}
        </p>
      ),
      description: 'Please try after sometime.'
    });
  }
}

export function* watchPostCreateMatchingConfigData() {
  yield takeEvery(NS_POST_CREATE_MATCHING_CONFIG, function* ({ payload }) {
    yield fork(postCreateMatchingConfigWorker, payload);
  });
}

function* getMatchingConfigByIdDataWorker(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(getNSMatchingConfigByIdService, payload);
    yield put(getNSMatchingConfigByIdSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(getNSMatchingConfigByIdFail({ error: '' }));
    yield put(ga.fetchFailed({ error: '' }));
  }
}

export function* watchGetMatchingConfigByIdData() {
  yield takeEvery(NS_GET_MATCHING_CONFIG_BY_ID, function* ({ payload }) {
    yield fork(getMatchingConfigByIdDataWorker, payload);
  });
}

function* putUpdateMatchingConfigWorker(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(putNSUpdateMatchingConfigAPI, payload);
    if (response?.status === 200 || response?.status === 201) {
      notification.open({
        message: (
          <p>
            <i style={{ color: '#2ecc71' }} className="fa fa-check"></i>
            &nbsp;&nbsp;Success
          </p>
        ),
        description: `${payload.name} is updated successfully.`
      });
      yield put(putNSUpdateMatchingConfigSuccess(response.data));
      yield put(ga.fetchSuccess());
      yield put(push(`${ROUTE_AMLS_SMART_SCREENING}/matchingConfig`));
    } else throw { errorMessage: response?.data?.msg };
  } catch (error) {
    yield put(putNSUpdateMatchingConfigFail({ error: '' }));
    yield put(ga.fetchFailed({ error: '' }));
    notification.open({
      message: (
        <p>
          <i style={{ color: '#e74c3c' }} className="fa fa-close"></i>
          &nbsp;&nbsp;{' '}
          {error?.errorMessage ? error.errorMessage : 'Something went wrong !'}
        </p>
      ),
      description: 'Please retry!'
    });
  }
}

export function* watchPutUpdateMatchingConfigData() {
  yield takeEvery(NS_PUT_UPDATE_MATCHING_CONFIG, function* ({ payload }) {
    yield fork(putUpdateMatchingConfigWorker, payload);
  });
}

function* getMatchingConfigWorker(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(getNSMatchingConfigAPI, payload);
    if (response?.status === 200 || response?.status === 201) {
      yield put(getNSMatchingConfigSuccess(response.data));
      yield put(ga.fetchSuccess());
    } else throw { errorMessage: response?.data?.msg };
  } catch (error) {
    yield put(getNSMatchingConfigFail({ error: '' }));
    yield put(ga.fetchFailed({ error: '' }));
    notification.open({
      message: (
        <p>
          <i style={{ color: '#e74c3c' }} className="fa fa-close"></i>
          &nbsp;&nbsp;{' '}
          {error?.errorMessage ? error.errorMessage : 'Something went wrong !'}
        </p>
      ),
      description: 'Failed to retrieve matching config information'
    });
  }
}

export function* watchGetMatchingConfigData() {
  yield takeEvery(NS_GET_MATCHING_CONFIG, function* ({ payload }) {
    yield fork(getMatchingConfigWorker, payload);
  });
}

function* getMatchingConfigRiskIndicatorListWorker() {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(getMatchingConfigRiskIndicatorList);
    yield put(getNSMatchingConfigRiskIndicatorListSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(getNSMatchingConfigRiskIndicatorListFail(error));
    yield put(ga.fetchFailed({ error: '' }));
  }
}

export function* watchGetMatchingConfigRiskIndicatorList() {
  yield takeEvery(NS_GET_MATCHING_CONFIG_RISK_INDICATOR_LIST, function* () {
    yield fork(getMatchingConfigRiskIndicatorListWorker);
  });
}

function* getMatchingConfigRiskIndicatorDataWorker(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      getMatchingConfigRiskIndicatorsParameters,
      payload
    );
    let data = [];
    forEach(response.data, function (obj) {
      let p = [];
      forEach(obj?.parameterList, (parameter) => {
        let o = {
          ...parameter,
          recommendedScore:
            parameter.recommendedScore >= 1 ? 1 : parameter.recommendedScore
        };
        p.push(o);
      });

      data.push({
        ...obj,
        parameterList: p
      });
    });
    yield put(getNSMatchingConfigRiskIndicatorParametersSuccess(data));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: 'Error in risk indicator api call' }));
  }
}

export function* watchGetMatchingConfigRiskParametersData() {
  yield takeEvery(
    NS_GET_MATCHING_CONFIG_RISK_INDICATORS_DATA,
    function* ({ payload }) {
      yield fork(getMatchingConfigRiskIndicatorDataWorker, payload);
    }
  );
}
